import { createAction } from 'redux-actions';
import { instance } from "../../../config/interceptor";

export const cleanupAction = createAction('CLEANUP_SELECT_LIBRARIES');

export const cleanup = ()  => async (dispatch) => {
  dispatch(cleanupAction());
}

export const getActivitySurveyRequest = createAction('SELECT_LIBRARIES_GET_ACTIVITY_REQUEST');
export const getActivitySurveySuccess = createAction('SELECT_LIBRARIES_GET_ACTIVITY_SUCCESS');
export const getActivitySurveyError = createAction('SELECT_LIBRARIES_GET_ACTIVITY_ERROR');

export const getActivitySurvey = (id) => async (dispatch) => {
  try {
    dispatch(getActivitySurveyRequest());
    const resp = await instance.get(`/v1/ActivitySurvey/GetByActivityId/${id}`);
    
    dispatch(getActivitySurveySuccess(resp.data));

  } catch (e) {
    if(e.response && e.response.data && e.response.data.description)
      dispatch(getActivitySurveyError(e.response.data.description));
    else
      dispatch(getActivitySurveyError(e.message));
  }
};

export const getLibrariesRequest = createAction('SELECT_LIBRARIES_GET_LIST_REQUEST');
export const getLibrariesSuccess = createAction('SELECT_LIBRARIES_GET_LIST_SUCCESS');
export const getLibrariesError = createAction('SELECT_LIBRARIES_GET_LIST_ERROR');

export const getLibraries = (applicationModuleId) => async (dispatch) => {
  try {
    dispatch(getLibrariesRequest());
    const resp = await instance.get(`/v1/Library/GetListByModuleId`, {
      params: {
        applicationModuleId
      }
    });
    
    dispatch(getLibrariesSuccess(resp.data));

  } catch (e) {
    if(e.response && e.response.data && e.response.data.description)
      dispatch(getLibrariesError(e.response.data.description));
    else
      dispatch(getLibrariesError(e.message));
  }
};

export const confirmLibrariesRequest = createAction('SELECT_LIBRARIES_CONFIRM_REQUEST');
export const confirmLibrariesSuccess = createAction('SELECT_LIBRARIES_CONFIRM_SUCCESS');
export const confirmLibrariesError = createAction('SELECT_LIBRARIES_CONFIRM_ERROR');

export const confirmLibraries = (data) => async (dispatch) => {
  try {
    dispatch(confirmLibrariesRequest());
    const resp = await instance.post(`/v1/ActivitySurvey/UpdateLibraryIds`, data);
    
    dispatch(confirmLibrariesSuccess(resp.data.data));

  } catch (e) {
    if(e.response && e.response.data && e.response.data.description)
      dispatch(confirmLibrariesError(e.response.data.description));
    else
      dispatch(confirmLibrariesError(e.message));
  }
};